var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 59,
    viewBox: "0 0 57 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.158203,
    width: 56.8417,
    height: 58.0146,
    rx: 28.4208,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6516_10379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9158 25.039H21.1894C22.2431 25.039 23.1052 25.9319 23.1052 27.0232V36.9441C23.1052 38.0354 22.2431 38.9283 21.1894 38.9283H20.9158C19.8621 38.9283 19 38.0354 19 36.9441V27.0232C19 25.9319 19.8621 25.039 20.9158 25.039ZM28.5788 19.0864C29.6325 19.0864 30.4946 19.9793 30.4946 21.0706V36.9441C30.4946 38.0354 29.6325 38.9283 28.5788 38.9283C27.5251 38.9283 26.6631 38.0354 26.6631 36.9441V21.0706C26.6631 19.9793 27.5251 19.0864 28.5788 19.0864ZM36.2419 30.4246C37.2955 30.4246 38.1576 31.3175 38.1576 32.4088V36.9441C38.1576 38.0354 37.2955 38.9283 36.2419 38.9283C35.1882 38.9283 34.3261 38.0354 34.3261 36.9441V32.4088C34.3261 31.3175 35.1882 30.4246 36.2419 30.4246Z",
    fill: "#456EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6516_10379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 34.0146,
    fill: "white",
    transform: "translate(12.1582 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightUnits);
export default __webpack_public_path__ + "static/media/weightUnits.45b4cd8e8a37fe125ed7143c46f2f051.svg";
export { ForwardRef as ReactComponent };